<div class="row" *ngIf="service">
    <div class="col-12 p-4">
      <primary-text-button (click)="copyService()">
        {{ 'Export service' | translate }}
      </primary-text-button>
      <drawer [title]="'Download'"
              [contextLabel]="service.name"
              [contextVariant]="'neutral'"
              (saveEvent)="initCopy();" [saveLabel]="'Download'" [isClosed]="!showCopyServiceModal.value" (closeEvent)="closeExport()">
        <service-copy-modal [serviceName]="service.name" [serviceId]="serviceId" (formSubmit)="downloadServiceJson($event)"></service-copy-modal>
      </drawer>
      <service-file-uploader class="d-inline-flex" (fileIdChanged)="importOnTop($event)" (uploadInput)="importOnTop($event)" [serviceUrl]="'validate_catalogs?serviceId=' + serviceId"
                               [hideIcon]="true" buttonLabel="{{ 'Import on top of this service' | translate }}" [simpleButton]="true"></service-file-uploader>
    </div>

    <div class="col-12 col-md-12 pt-4 pl-4 pr-4 expanded-list" *ngIf="snapshotList?.length > 0">
        <div class="form-group">
            <div class="row">
                <div class="col">
                    <label class="input-label">{{ 'Snapshots' | translate }}</label>
                    <div class="table-items">
                        <div class="item">
                            <div class="row ">
                                <div class="col-md-3 milli mb-0 font-weight-bold">{{ 'Type' | translate }}</div>
                                <div class="col-md-3 milli mb-0 font-weight-bold">{{ 'User' | translate }} / {{ 'Date' | translate }}</div>
                                <div class="col-md-1 milli mb-0 font-weight-bold">{{ 'Feedback' | translate }}</div>
                                <div class="col-md-2 milli mb-0 font-weight-bold">{{ 'Status' | translate }}</div>
                                <div class="col-md-2 milli mb-0 font-weight-bold">{{ 'Total time' | translate }}</div>
                                <div class="col-md-1 milli mb-0 font-weight-bold text-center">{{ 'File' | translate }}</div>
                            </div>
                        </div>
                        <div
                                *ngFor="let p of snapshotList"
                                class="item"
                                (click)="showFeedback(p)">
                                <div class="row align-items-center">
                                    <div class="col-md-3 milli mb-0 text-left align-items-start">
                                        {{ p.type }}
                                    </div>
                                    <div class="col-md-3 milli mb-0 text-left">
                                        <span class="item-author d-block">{{  formatPublisher(p.username) }}</span>
                                        <strong class="item-date d-block">{{ p.date | date: 'dd-MM-yyyy H:mm' }}</strong>
                                    </div>
                                    <div class="col-md-1 align-items-start text-left">
                                        <a *ngIf="p.feedback" tooltip="{{ 'Feedback' | translate }}" class="text-warning cursor-pointer"><i class="far fa-circle-exclamation"></i></a>
                                    </div>
                                    <div class="col-md-2 align-items-start text-left">
                                        <div class="text-success" *ngIf="p.importTotalTime===undefined">{{ 'in progress' | translate }}</div>
                                        <div class="text-success" *ngIf="p.success==true">{{ 'success' | translate }}</div>
                                        <div class="text-danger" *ngIf="p.importTotalTime!=undefined && p.success==false"
                                            tooltip="{{ 'Click to see reason' | translate }}">{{ 'failed' | translate }}</div>
                                    </div>
                                    <div class="col-md-2 align-items-start text-left">{{ convertMillisecToMinSec(p.importTotalTime) }}</div>
                                    <div class="col-md-1 align-items-center text-center">
                                        <i
                                                (click)="downloadSnapshotFile(p.id)"
                                                tooltip="{{ 'Download file' | translate }}"
                                                style="cursor:pointer"
                                                class="fas fa-file"
                                        ></i>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col px-3 pt-3" *ngIf="p.showReason">
                                        <div class="alert alert-warning" role="alert" [innerHTML]="p.feedback"></div>
                                    </div>
                                </div>
                        </div>
                        <div class="app-pagination row" *ngIf="maxPage > 0">
                            <ul class="pagination">
                                <li class="page-item" *ngIf="page > 0">
                                    <a class="page-link" (click)="getPage(page - 1)">
                                        <span aria-hidden="true">&laquo;</span>
                                    </a>
                                </li>
                                <li
                                        *ngFor="let p of getPages()"
                                        class="page-item"
                                        [ngClass]="{'active': p === page}">
                                    <a
                                            (click)="getPage(p)"
                                            class="page-link">
                                        {{p + 1}}
                                    </a>
                                </li>
                                <li class="page-item" *ngIf="page < maxPage">
                                    <a class="page-link" (click)="getPage(page + 1)">
                                        <span aria-hidden="true">&raquo;</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
  </div>
